export enum SiteType {
    Managed = 'Managed',
    Account = 'Account',
    Adhoc = 'Adhoc',
}
